(function () {
  angular
    .module("akitabox.ui.dialogs.schedule.reopen")
    .controller(
      "ReopenScheduleDialogController",
      ReopenScheduleDialogController
    );

  /* @ngInject */
  function ReopenScheduleDialogController(
    // Angular
    $q,
    // Material
    $mdDialog,
    // Services
    ToastService,
    ScheduleService
  ) {
    var self = this;

    // Attributes
    self.saving = false;
    // have to set default false in order to run tests since scheduleIDs is passed in through locals
    self.multiple = self.schedules ? self.schedules.length > 1 : false;

    // Functions
    self.cancel = $mdDialog.cancel;
    self.reopen = reopen;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Reopen maintenance schedules
     */
    function reopen() {
      self.saving = true;
      self.determinateValue = 0;
      var increment = (1 / self.schedules.length) * 100;
      var promiseArray = [];

      // Reopen the maintenance schedules
      for (var i = 0; i < self.schedules.length; i++) {
        promiseArray[i] = ScheduleService.reopen(
          self.schedules[i].building._id,
          self.schedules[i]._id
        ).then(function (reopenedSchedule) {
          self.determinateValue += increment;
          return reopenedSchedule._id;
        });
      }

      $q.all(promiseArray)
        .then(function (reopenedScheduleIDs) {
          $mdDialog.hide(reopenedScheduleIDs);
        })
        .catch(ToastService.showError)
        .finally(function () {
          self.saving = false;
        });
    }
  }
})();
